module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAMAAAAiV0Z6AAAARVBMVEUAAACDPCiDPSmEPSmAQCKDPiqHQCiEPSmEPSmDPSmEPSmDPSiCPSuCPSiFQCuFOiuAQCiDPimEOyeDPimFPSuDPSmDPSlwDmzqAAAAFnRSTlMAQO/fEIAgn5C/r39gYDAwIM9wb2BQXwEEpQAAAIRJREFUKM+F0NkKxCAMheEYt1btMtt5/0cdiu1EnUD/G+EjhCBdudUEGnKZATxKh7tFLbdqcWUEP/g1i06iLBohiXp11ohGUhZzaNSlEzfqWmaG9Y7ucmWK5RgzU/TmxBfXnba+KRyYMWRDc2v3Fwn/rcSKvglKXld1w0JPQDttN0Mb0RdpehcTv+NvrAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/icon-user.png
// module id = enPz
// module chunks = 0